module.exports = __webpack_public_path__ + "static/img/DARREN_LEHMANN.628d314.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DARREN_LEHMANN.jpg
// module id = 1b37
// module chunks = 0